module.exports = __webpack_public_path__ + "components/country-flag/static/ao-5c3d828e4fd7896ef3ebc14456fd7709.svg";